import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  Tab,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  tambahAreaManager,
  getAllAreaManager,
  getAllClient,
  getAllCabang,
} from "stores";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { penempatanAreaManager } from "stores";
import { editStatusAreaManager } from "stores";
import { resetPassword } from "stores";

function ListAreaManager() {
  const dispatch = useDispatch();
  const storeClient = useSelector((state) => state.clientReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);
  const areaManager = useSelector((state) => state.areaManagerReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [modalAreaManager, setModalAreaManager] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalUbahPenempatan, setModalUbahPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [nik, setNik] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listAreaManager, setListAreaManager] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [listCabang, setListCabang] = React.useState([]);
  const [idClientAM, setIdClientAM] = React.useState("");
  const [idCabang, setIdCabang] = React.useState(null);
  const [idAreaManager, setIdAreaManager] = React.useState("");
  const [listDetailCabang, setListDetailCabang] = React.useState([]);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const submitAreaManager = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }

    tambahAreaManager({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      idClient: idClientAM,
    })
      .then((response) => {
        if (response.data.status === 200) {
          const newPassword = response.data.defaultPassword;

          // STEP 1: Tutup modal form input Area Manager terlebih dahulu
          handleModalClose();
          if (typeof setModalAreaManager === "function") {
            setModalAreaManager(false); // Sesuaikan dengan nama state penutup modal AM milikmu
          }

          // STEP 2: Beri jeda 250ms agar animasi penutupan modal Bootstrap selesai dengan smooth
          setTimeout(() => {
            // STEP 3: Tampilkan SweetAlert besar dengan proteksi tombol konfirmasi terkunci
            Swal.fire({
              title: "⚠️ PENTING: SIMPAN PASSWORD INI!",
              icon: "success",
              width: "700px", // Memperbesar pop-up agar menjadi pusat perhatian utama
              confirmButtonColor: "#1D3557",
              confirmButtonText: "Saya Sudah Menyalin & Selesai",
              allowOutsideClick: false, // Mencegah admin menutup modal secara tidak sengaja
              html: `
              <div style="text-align: left; background-color: #fffbeb; padding: 20px; border: 2px solid #fef3c7; border-radius: 12px; margin-top: 15px;">
                <p style="margin-bottom: 12px; color: #b45309; font-size: 15px; font-weight: 600; line-height: 1.5;">
                  Akun Area Manager berhasil dibuat! Kredensial ini <span style="color: #dc2626; font-weight: 800;">HANYA MUNCUL SEKALI</span>. 
                  Silakan klik tombol <strong>Copy</strong> untuk mengaktifkan tombol selesai:
                </p>
                
                <div style="display: flex; align-items: center; justify-content: space-between; background: white; padding: 14px 20px; border: 2px solid #1D3557; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
                  <code id="raw-password" style="font-size: 20px; font-weight: 800; color: #1d3557; letter-spacing: 0.5px;">${newPassword}</code>
                  <button 
                    id="btn-copy-pass"
                    type="button"
                    style="background: #1D3557; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700; transition: all 0.2s ease; min-width: 80px;"
                  >
                    Copy
                  </button>
                </div>
              </div>
              <div id="copy-warning-text" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 15px; color: #dc2626; font-size: 13px; font-weight: 700;">
                <i class="fas fa-lock"></i>
                <span>Tombol konfirmasi terkunci! Silakan salin password terlebih dahulu.</span>
              </div>
            `,
              didOpen: () => {
                const confirmBtn = Swal.getConfirmButton();
                const copyBtn = document.getElementById("btn-copy-pass");
                const warningText =
                  document.getElementById("copy-warning-text");

                // Kunci tombol konfirmasi utama saat modal pertama kali terbuka
                if (confirmBtn) {
                  confirmBtn.disabled = true;
                  confirmBtn.style.opacity = "0.5";
                  confirmBtn.style.cursor = "not-allowed";
                }

                if (copyBtn) {
                  copyBtn.addEventListener("click", () => {
                    // Proses salin password ke clipboard
                    navigator.clipboard.writeText(newPassword);

                    // Perbarui visual tombol copy menjadi sukses
                    copyBtn.innerText = "Copied!";
                    copyBtn.style.backgroundColor = "#10B981";

                    // Buka kunci tombol konfirmasi utama setelah berhasil disalin
                    if (confirmBtn) {
                      confirmBtn.disabled = false;
                      confirmBtn.style.opacity = "1";
                      confirmBtn.style.cursor = "pointer";
                    }

                    // Ubah indikator peringatan di bawah menjadi hijau/aman
                    if (warningText) {
                      warningText.style.color = "#10B981";
                      warningText.innerHTML = `<i class="fas fa-check-circle"></i> <span>Password berhasil disalin! Anda sekarang dapat menutup jendela ini.</span>`;
                    }
                  });
                }
              },
            }).then((result) => {
              // STEP 4: Setelah Admin selesai menyalin dan menutup Swal, baru kita refresh data tabel di background
              if (result.isConfirmed || result.isDismissed) {
                getAllAreaManager(dispatch, { idClient: "" });
              }
            });
          }, 250);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message || "Terjadi kesalahan",
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error.response?.data?.message || "Terjadi kesalahan pada sistem.",
        });
      });
  };

  // const submitAreaManager = () => {
  //   if (nik.length < 16) {
  //     Swal.fire({
  //       title: "NIK harus 16 digit !!",
  //       icon: "warning",
  //     });
  //     return;
  //   }
  //   tambahAreaManager({
  //     nik: nik,
  //     nama: nama,
  //     nopeg: nopeg,
  //     idClient: idClientAM,
  //   })
  //     .then((response) => {
  //       if (response.data.status === 200) {
  //         Swal.fire({
  //           position: "center",
  //           icon: "success",
  //           title: response.data.message,
  //           showConfirmButton: false,
  //           timer: 1000,
  //         });
  //         handleModalClose();
  //         getAllAreaManager(dispatch, { idClient: "" });
  //       } else if (response.data.status === 400) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: response.data.message,
  //         });
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: response.data.message,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("ERRORRRR", error);
  //     });
  // };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusAreaManager({
      idAreaManager: idAreaManager,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllAreaManager(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanAreaManager({
        idAreaManager: idAreaManager,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllAreaManager(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihCabang(null);
    setIdCabang(null);
    setPilihClient(null);
    setModalAreaManager(false);
    setModalPenempatan(false);
    setIdClientAM("");
    setPilihClient("");
    setNik("");
    setNopeg("");
    setNama("");
  };

  React.useEffect(() => {
    let tmp =
      areaManager.listAreaManager &&
      areaManager.listAreaManager.map((val) => {
        // 1. Logika Penempatan (Hanya 1 penempatan dan nama cabangnya kosong)
        const isBelumPenempatan =
          val.penempatan.length === 1 && !val.penempatan[0].namaCabang;

        // 2. Logika Akses Edit Status (Bisa diklik jika Super Admin ATAU memenuhi syarat penempatan)
        const canEditStatus = auth.role === "super admin" || isBelumPenempatan;

        // 3. Logika Penempatan Cabang (Bisa diklik jika status aktif)
        const isAktif = val.status === "aktif";

        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center">
              {/* BUTTON PENEMPATAN */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Penempatan Area Manager</Tooltip>}
              >
                <Button
                  disabled={!isAktif}
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: isAktif ? "#447DF7" : "#E2E8F0",
                    border: "none",
                    color: isAktif ? "white" : "#94A3B8",
                    cursor: isAktif ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    setIdAreaManager(val._id);
                    getAllCabang(dispatch, { idClient: val.idClient });
                    setModalPenempatan(!modalPenempatan);
                  }}
                >
                  <i
                    className="fas fa-map-marked-alt"
                    style={{ fontSize: "16px" }}
                  ></i>
                </Button>
              </OverlayTrigger>

              {/* BUTTON EDIT STATUS (Dengan Bypass Super Admin) */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Edit Status</Tooltip>}
              >
                <Button
                  disabled={!canEditStatus} // Menggunakan logika gabungan tadi
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: canEditStatus ? "#76CD26" : "#E2E8F0",
                    border: "none",
                    color: canEditStatus ? "white" : "#94A3B8",
                    cursor: canEditStatus ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    setIdAreaManager(val._id);
                    setModalEdit(!modalEdit);
                  }}
                >
                  <i
                    className="fas fa-user-cog"
                    style={{ fontSize: "16px" }}
                  ></i>
                </Button>
              </OverlayTrigger>

              {/* BUTTON RESET PASSWORD */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Reset Password</Tooltip>}
              >
                <Button
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: "#F87171",
                    border: "none",
                    color: "white",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#EF4444")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#F87171")
                  }
                  onClick={async () => {
                    const result = await Swal.fire({
                      title: "Reset Password",
                      text: `Apakah Anda yakin ingin mereset password pengguna ${val.nama}?`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#1D3557",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Ya, Reset Password!",
                    });

                    if (result.isConfirmed) {
                      try {
                        // 1. Panggil API reset password
                        const response = await resetPassword({
                          idUser: val._id,
                          role: val.role,
                        });

                        // 2. Ambil password plain text dari response backend kamu
                        const newPassword = response.data.defaultPassword;

                        // 3. Tampilkan SweetAlert Sukses berukuran besar dengan tombol konfirmasi terkunci
                        Swal.fire({
                          title: "⚠️ PENTING: SIMPAN PASSWORD INI!",
                          icon: "success",
                          width: "700px", // Membuat ukuran pop-up lebih besar dan dominan
                          confirmButtonColor: "#1D3557",
                          confirmButtonText: "Saya Sudah Menyalin & Selesai",
                          allowOutsideClick: false, // Mencegah admin tidak sengaja klik luar modal
                          html: `
                        <div style="text-align: left; background-color: #fffbeb; padding: 20px; border: 2px solid #fef3c7; border-radius: 12px; margin-top: 15px;">
                          <p style="margin-bottom: 12px; color: #b45309; font-size: 15px; font-weight: 600; line-height: 1.5;">
                            Password berhasil direset! Sistem telah men-hash password baru ini demi keamanan. 
                            <br><span style="color: #dc2626; font-weight: 800;">Kredensial ini HANYA MUNCUL SEKALI</span>. 
                            Silakan klik tombol <strong>Copy</strong> untuk mengaktifkan tombol selesai:
                          </p>
                          
                          <div style="display: flex; align-items: center; justify-content: space-between; background: white; padding: 14px 20px; border: 2px solid #1D3557; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
                            <code id="raw-password" style="font-size: 20px; font-weight: 800; color: #1d3557; letter-spacing: 0.5px;">${newPassword}</code>
                            <button 
                              id="btn-copy-pass"
                              type="button"
                              style="background: #1D3557; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700; transition: all 0.2s ease; min-width: 80px;"
                            >
                              Copy
                            </button>
                          </div>
                        </div>
                        <div id="copy-warning-text" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 15px; color: #dc2626; font-size: 13px; font-weight: 700;">
                          <i class="fas fa-lock"></i>
                          <span>Tombol konfirmasi terkunci! Silakan salin password terlebih dahulu.</span>
                        </div>
                      `,
                          didOpen: () => {
                            const confirmBtn = Swal.getConfirmButton();
                            const copyBtn =
                              document.getElementById("btn-copy-pass");
                            const warningText =
                              document.getElementById("copy-warning-text");

                            // Secara default, kunci tombol konfirmasi utama
                            if (confirmBtn) {
                              confirmBtn.disabled = true;
                              confirmBtn.style.opacity = "0.5";
                              confirmBtn.style.cursor = "not-allowed";
                            }

                            if (copyBtn) {
                              copyBtn.addEventListener("click", () => {
                                // Proses copy teks password ke clipboard
                                navigator.clipboard.writeText(newPassword);

                                // Modifikasi tombol copy menjadi sukses
                                copyBtn.innerText = "Copied!";
                                copyBtn.style.backgroundColor = "#10B981";

                                // Buka kunci tombol konfirmasi utama setelah berhasil di-copy
                                if (confirmBtn) {
                                  confirmBtn.disabled = false;
                                  confirmBtn.style.opacity = "1";
                                  confirmBtn.style.cursor = "pointer";
                                }

                                // Ubah teks peringatan di bawah box menjadi hijau/aman
                                if (warningText) {
                                  warningText.style.color = "#10B981";
                                  warningText.innerHTML = `<i class="fas fa-check-circle"></i> <span>Password berhasil disalin! Anda sekarang dapat menutup jendela ini.</span>`;
                                }
                              });
                            }
                          },
                        });
                      } catch (error) {
                        Swal.fire({
                          title: "Error",
                          text:
                            error.response?.data?.message ||
                            "Terjadi kesalahan pada sistem.",
                          icon: "error",
                        });
                      }
                    }
                  }}
                >
                  <i className="fas fa-key" style={{ fontSize: "15px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListAreaManager(tmp);
  }, [areaManager.listAreaManager]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });
    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    header: {
      style: { minHeight: "56px" },
    },
    headRow: {
      style: {
        backgroundColor: "#F8F9FC",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "#E3E6F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "13px",
        color: "#4E73DF", // Warna identitas AM
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        minHeight: "70px", // Row lebih tinggi agar data tidak sesak
        "&:not(:last-child)": {
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: "#E3E6F0",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#5A5C69",
      },
    },
  };

  const colAreaManager = [
    {
      name: "No",
      width: "60px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "User & Karyawan",
      minWidth: "200px",
      cell: (row) => (
        <div>
          <div className="fw-bold text-dark">{row.nama}</div>
          <small className="text-muted">
            {row.nopeg} | {row.kodeUser}
          </small>
        </div>
      ),
    },
    {
      name: "BPD",
      minWidth: "150px",
      omit: auth.role !== "super admin",
      selector: (row) => row.namaClient[0],
    },
    {
      name: "Cabang Penempatan",
      minWidth: "250px",
      cell: (row) => {
        // Jika tidak ada penempatan
        if (
          row.penempatan.length === 0 ||
          (row.penempatan.length === 1 && !row.penempatan[0].namaCabang)
        ) {
          return (
            <div
              className="d-flex align-items-center text-muted"
              style={{ fontStyle: "italic", fontSize: "13px" }}
            >
              <i className="fas fa-minus-circle mr-2 opacity-50"></i> Belum ada
              penempatan
            </div>
          );
        }

        // Jika ada penempatan
        return (
          <div className="py-2">
            {/* Nama Cabang Utama */}
            <div className="d-flex align-items-center mb-1">
              <i
                className="fas fa-map-marker-alt text-danger mr-2"
                style={{ fontSize: "12px" }}
              ></i>
              <span
                style={{
                  fontWeight: "700",
                  color: "#2D3748",
                  fontSize: "14px",
                }}
              >
                {row.penempatan[0].namaCabang}
              </span>
            </div>

            {/* Indikator Cabang Lainnya (Tanpa Blok Warna) */}
            {row.penempatan.length > 1 && (
              <div
                className="d-flex align-items-center mt-1"
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#4E73DF",
                  paddingLeft: "20px", // Agar sejajar di bawah teks nama cabang
                }}
                onClick={() => {
                  setListDetailCabang(row);
                  setModalDetail(true);
                }}
              >
                <span
                  style={{
                    borderBottom: "1px dashed #4E73DF",
                    fontWeight: "600",
                  }}
                >
                  <i
                    className="fas fa-external-link-alt mr-1"
                    style={{ fontSize: "10px" }}
                  ></i>
                  Lihat {row.penempatan.length - 1} cabang lainnya
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      name: "Status",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isActive = row.status === "aktif";
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              backgroundColor: isActive ? "#D1FAE5" : "#FEE2E2",
              color: isActive ? "#065F46" : "#991B1B",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10B981" : "#EF4444",
                marginRight: "8px",
              }}
            ></span>
            {isActive ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "150px",
      center: true,
      omit: !(auth.role === "super admin" || auth.role === "admin"),
      cell: (row) => row.action, // Pastikan row.action merender button aksi Anda
    },
  ];

  React.useEffect(() => {
    getAllAreaManager(dispatch, { idClient: "" });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      {/* <Modal
        size="lg"
        show={modalUbahPenempatan}
        onHide={() => {
          handleModalClose();
          setModalUbahPenempatan(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title
                as="h4"
                style={{ fontWeight: "bold", color: "black" }}
              >
                Form Ubah Penempatan Area Manager
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Form action="#" method="#">
                <Form.Group>
                  <label style={{ color: "black" }}>Pilih Cabang</label>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    name="Pilih Cabang"
                    value={pilihCabang}
                    onChange={(value) => {
                      setPilihCabang(value);
                      setIdCabang(value.value);
                    }}
                    options={listCabang}
                    placeholder="Pilih Cabang"
                  />
                </Form.Group>
              </Form>
            </Card.Body>
            <Card.Footer>
              <Button
                className="btn-wd mr-0"
                variant="primary"
                // onClick={submitUbahPenempatan}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal> */}

      <Modal
        size="lg"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        scrollable
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-info-circle fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3 className="fw-800 text-dark mb-1">Detail Penempatan</h3>
            <p className="text-muted">
              Informasi jangkauan wilayah Area Manager
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              {/* INFO PROFIL */}
              <div className="mb-4 pb-3 border-bottom">
                <Row className="mb-2">
                  <Col xs="5" sm="4" className="text-muted fw-bold small">
                    NAMA LENGKAP
                  </Col>
                  <Col xs="7" sm="8" className="text-dark fw-bold">
                    : {listDetailCabang.nama}
                  </Col>
                </Row>
                <Row className="mb-0">
                  <Col xs="5" sm="4" className="text-muted fw-bold small">
                    JABATAN
                  </Col>
                  <Col xs="7" sm="8" className="text-dark fw-bold">
                    : Area Manager
                  </Col>
                </Row>
              </div>

              {/* LIST CABANG DENGAN TOTAL */}
              <div className="bg-light p-3" style={{ borderRadius: "15px" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold text-primary m-0">
                    <i className="fas fa-map-marked-alt mr-2"></i>Daftar Cabang
                  </h6>
                  {/* BADGE TOTAL CABANG */}
                  <span
                    className="badge bg-white text-primary shadow-sm px-3 py-2"
                    style={{
                      borderRadius: "10px",
                      fontSize: "12px",
                      border: "1px solid #4E73DF",
                    }}
                  >
                    Total:{" "}
                    <span className="fw-800">
                      {listDetailCabang.penempatan?.length || 0}
                    </span>{" "}
                    Cabang
                  </span>
                </div>

                <div
                  style={{
                    maxHeight: "30vh",
                    overflowY: "auto",
                    paddingRight: "5px",
                  }}
                >
                  <ul className="list-group list-group-flush bg-transparent">
                    {listDetailCabang.penempatan &&
                    listDetailCabang.penempatan.length > 0 ? (
                      listDetailCabang.penempatan.map((val, index) => (
                        <li
                          key={index}
                          className="list-group-item bg-transparent border-0 py-2 ps-0 text-dark fw-600 d-flex align-items-center"
                        >
                          <div
                            className="bg-success rounded-circle mr-3 d-flex align-items-center justify-content-center"
                            style={{
                              width: "22px",
                              height: "22px",
                              minWidth: "22px",
                            }}
                          >
                            <i
                              className="fas fa-check text-white"
                              style={{ fontSize: "10px" }}
                            ></i>
                          </div>
                          {val.namaCabang}
                        </li>
                      ))
                    ) : (
                      <li className="list-group-item bg-transparent border-0 text-muted italic">
                        Belum ada cabang terdaftar.
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => setModalPenempatan(false)}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-map-pin fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Form Penempatan</h3>
            <p className="text-muted">
              Pilih cabang koordinasi untuk Area Manager
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  placeholder="Cari Cabang..."
                />
              </Form.Group>
              <Button
                className="btn-block p-3"
                style={{
                  border: "none",
                  backgroundColor: "#447DF7",
                  borderRadius: "15px",
                  fontWeight: "800",
                }}
                onClick={submitPenempatan}
              >
                SIMPAN PENEMPATAN
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-user-shield fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Edit Status AM</h3>
            <p className="text-muted">
              Perbarui status aktifasi akun Area Manager
            </p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">
                  Pilih Status Baru
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={status}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Tidak Aktif" },
                  ]}
                />
              </Form.Group>
              <Button
                className="btn-block p-3"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                }}
                onClick={checkStatus}
              >
                SIMPAN PERUBAHAN
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalAreaManager}
        onHide={() => {
          handleModalClose();
          setModalAreaManager(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-user-plus fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Tambah Area Manager</h3>
            <p className="text-muted">
              Daftarkan Area Manager baru ke dalam sistem
            </p>
          </div>

          <Form>
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px" }}
            >
              <Card.Body className="p-4">
                <Row>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">NIK</label>
                      <div className="position-relative">
                        <Form.Control
                          className="border-0 bg-light p-3"
                          style={{
                            borderRadius: "12px",
                            fontWeight: "600",
                            paddingRight: "80px",
                          }}
                          onChange={handleNikChange}
                          value={nik}
                          type="text"
                          placeholder="Masukkan NIK"
                        />
                        <small
                          className="position-absolute fw-bold"
                          style={{
                            right: "15px",
                            top: "15px",
                            color: "#94a3b8",
                          }}
                        >
                          {remainingDigits} digit
                        </small>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        Nama Lengkap
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setNama(e.target.value)}
                        placeholder="Nama Lengkap"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label className="fw-bold text-dark mb-2">
                        No Karyawan
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setNopeg(e.target.value)}
                        placeholder="Contoh: 12345"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  {auth.role === "super admin" && (
                    <Col md="6" className="mb-3">
                      <Form.Group>
                        <label className="fw-bold text-dark mb-2">
                          Pilih Client (BPD)
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          value={pilihClient}
                          onChange={(value) => {
                            setPilihClient(value);
                            setIdClientAM(value.value);
                          }}
                          options={listClient}
                          placeholder="Pilih Client"
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <div className="mt-4">
                  <Button
                    className="btn-block p-3"
                    style={{
                      border: "none",
                      backgroundColor: "#1D3557",
                      borderRadius: "15px",
                      fontWeight: "800",
                      boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                    }}
                    onClick={submitAreaManager}
                  >
                    SUBMIT DATA AM
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Modal.Body>
      </Modal>

      <Tab.Content className="mt-3">
        <Card className="border-0 bg-transparent">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
            {/* Tombol Tambah di Kiri */}
            <div className="mb-3 mb-md-0">
              {(auth.role === "super admin" || auth.role === "admin") && (
                <Button
                  onClick={() => setModalAreaManager(!modalAreaManager)}
                  className="btn-fill d-flex align-items-center shadow-sm"
                  style={{
                    backgroundColor: "#1D3557",
                    border: "none",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                  }}
                >
                  <i className="nc-icon nc-simple-add mr-2"></i>
                  <span>Tambah Area Manager</span>
                </Button>
              )}
            </div>

            {/* Search Bar di Kanan */}
            <div style={{ width: "100%", maxWidth: "350px" }}>
              <InputGroup
                className="shadow-sm border-0"
                style={{ borderRadius: "10px", overflow: "hidden" }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text className="bg-white border-0 text-muted">
                    <i className="nc-icon nc-zoom-split fw-bold"></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  className="border-0 ps-1"
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="Cari AM / No. Karyawan..."
                  style={{
                    height: "45px",
                    backgroundColor: "#f8f9fa",
                    boxShadow: "none",
                    fontSize: "0.95rem",
                  }}
                />
              </InputGroup>
            </div>
          </div>
        </Card>
      </Tab.Content>

      <Card
        className="border-0 shadow-sm overflow-hidden"
        style={{ borderRadius: "15px" }}
      >
        <DataTable
          columns={colAreaManager}
          data={listAreaManager.filter(
            (row) =>
              row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
              row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
          )}
          customStyles={customStyles}
          pagination
          paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
          paginationPerPage={itemsPerPage}
          onChangePage={handlePageChange}
          highlightOnHover
          responsive
        />
      </Card>
    </>
  );
}
export default ListAreaManager;
